import { convertTz } from "../utils/timeHelpers";

export const updateCohortTimezone = (cohorts) => {
  return (
    cohorts?.map((c) => {
      return {
        ...c,
        schedules: c.schedules.map((s) => {
          return {
            ...s,
            start_time: convertTz(s.start_time, c.timezone),
            end_time: convertTz(s.end_time, c.timezone),
          };
        }),
      };
    }) || []
  );
};
